class MotoTicker extends HTMLElement {
  connectedCallback() {
    const textEl = this.querySelector('.announcement-bar__text');
    if (!textEl) return;

    const message = textEl.textContent.trim();
    if (!message) return;

    const separator = this.getAttribute('data-separator') || '•';
    const repeatCount = 16;

    let itemsHtml = '';
    for (let i = 0; i < repeatCount; i++) {
      itemsHtml += `<span class="moto-ticker__item">${this.escape(message)}</span>`;
      itemsHtml += `<span class="moto-ticker__sep" aria-hidden="true">${this.escape(separator)}</span>`;
    }

    const track = document.createElement('div');
    track.className = 'moto-ticker__track';
    track.setAttribute('aria-hidden', 'true');
    track.innerHTML = itemsHtml + itemsHtml;

    this.setAttribute('aria-label', message);
    this.querySelectorAll('.announcement-bar__slide').forEach((el) => {
      el.setAttribute('aria-hidden', 'true');
    });

    this.appendChild(track);
    this.classList.add('moto-ticker--ready');
  }

  escape(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
}

if (!customElements.get('moto-ticker')) {
  customElements.define('moto-ticker', MotoTicker);
}
